<div class="usa-modal__content">
    <div class="usa-modal__main define-modal-style">
        <h2 class="usa-modal__heading" id="modal-2-heading">
            {{businessType}} Extend Current Rates
        </h2>
        <div class="usa-prose">
            <div class="grid-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <ag-grid-angular *ngIf="showGrid" class="ag-theme-alpine" id="extendRatesGrid" [rowData]="rowData" [columnDefs]="columnDefs" [gridOptions]="hhgExtendRatesOptions" [overlayNoRowsTemplate]="overlayNoRowsTemplate" [suppressDragLeaveHidesColumns]="true">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
        <div class="usa-modal__footer">
            <ul class="usa-button-group">
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button" (click)="extendRates()">Extend</button>
                </li>
                <li class="usa-button-group__item">
                    <button type="button" class="usa-button usa-button-outline" (click)="resetRates()">Reset</button>
                </li>
            </ul>
        </div>
    </div>
    <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="closeModal()" data-close-modal>
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>